module.exports = __webpack_public_path__ + "img/Slider-Ad.1d8298c8.svg";